/**
 * OTP provider selector. Picks the implementation from VITE_OTP_PROVIDER.
 * The rest of the app imports `otpProvider` from here and nothing else.
 *
 * v1 default: 'clerk' — managed email OTP (Clerk sends the emails; free tier),
 * bridged to Firebase via the Apps Script token exchange.
 * 'email' (self-hosted Apps Script OTP, also free) is the fallback; 'firebase'
 * (paid phone SMS) and the SMS-gateway stubs remain selectable.
 */
import { otpProviderName } from '../env';
import type { OtpProvider } from './types';
import { clerkOtpProvider } from './clerkOtpProvider';
import { emailOtpProvider } from './emailOtpProvider';
import { firebaseOtpProvider } from './firebaseOtpProvider';
import { msg91Provider, fast2smsProvider, whatsappProvider } from './stubProviders';

function selectProvider(): OtpProvider {
  switch (otpProviderName) {
    case 'email':
      return emailOtpProvider;
    case 'firebase':
      return firebaseOtpProvider;
    case 'msg91':
      return msg91Provider;
    case 'fast2sms':
      return fast2smsProvider;
    case 'whatsapp':
      return whatsappProvider;
    case 'clerk':
    default:
      return clerkOtpProvider;
  }
}

export const otpProvider: OtpProvider = selectProvider();

export { isValidEmail } from './emailOtpProvider';
export type { OtpProvider, OtpConfirmation } from './types';
